import { render, staticRenderFns } from "./trifle-add.vue?vue&type=template&id=574de815&scoped=true&"
import script from "./trifle-add.vue?vue&type=script&lang=js&"
export * from "./trifle-add.vue?vue&type=script&lang=js&"
import style0 from "./trifle-add.vue?vue&type=style&index=0&lang=css&"
import style1 from "./trifle-add.vue?vue&type=style&index=1&id=574de815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574de815",
  null
  
)

export default component.exports